import * as Yup from "yup";

export const mobileValidationSchema = Yup.object({
  urlMobile: Yup.string().matches(/^((https?:\/\/)|(www\.))?[\w.-]+(:\d{4})?$/, "La URL no es válida. Debe comenzar con 'http://', 'https://' o 'www', y además contener el número de puerto (ej. 'https://localhost:9090')").required("URL Mobile es requerido"),
  surveyCompany: Yup.object({ id: Yup.string().required("Compañía de encuestas es requerido") }),
  userMobile: Yup.string().required("Usuario es requerido"),
  passwordMobile: Yup.string().required("Contraseña de Mobile es requerido"),
  tokenMobile: Yup.string().required("Token de Mobile es requerido"),
});